import React from "react";

import { ContactCrawlRelatedIndustriesFragmentParameter, ContactIndustryRelatedIndustryData } from "@/app/pages/contactDirectory/interface";
import { isUndefined, isNotUndefinedOrNull } from "@/shared/FunctionCore";
import "@/app/pages/contactIndustrySearch/styles/ContactCrawlRelatedIndustriesStyles.scss";

type ContentNaicsCodeProps = ContactIndustryRelatedIndustryData;

const renderIndustries = (relatedIndustries) => {
	if (isNotUndefinedOrNull(relatedIndustries)) {
		const industries = Object.keys(relatedIndustries).sort();

		return <ul className="crawl-rel-flex-component">

			{industries.map((industry, i) => (
				<li
					className="crawl-rel-list-comp-flex"
					key={`${i}-${industry}`}
				>
					<a
						className="crawl-rel-anchor-text"
						href={`contact-industry-search.${relatedIndustries[industry]}.html`}>
						{industry}
					</a>
				</li>
			))}
		</ul>
		{/* <a
					className="link-with-underline"
					href={`contact-industry-search.${relatedIndustries[industry]}.html`}
					key={`${i}-${industry}`}
				>
					{industry}
				</a> */}

	}
}

type ContactCrawlRelatedIndustriesFragmentComponentProps = ContactCrawlRelatedIndustriesFragmentParameter;

const ContactCrawlRelatedIndustries = (props: ContactCrawlRelatedIndustriesFragmentComponentProps): JSX.Element => (
	<div className="crawl-rel-bg-image">
		<div className="container">
			<div className="crawl-rel-component-container">
				<h3 className="crawl-rel-header-text">
					Find Contacts in Related Industries
				</h3>

				<div>

					{renderIndustries(props.relatedIndustries)}
					{/* <ContentNaicsCode relatedIndustryGroup={props?.contactIndustryRelatedIndustryData?.relatedIndustryGroup} /> */}
				</div>
			</div>
		</div>
	</div>
);

export default ContactCrawlRelatedIndustries